import unescapedText from 'I18n/utils/unescapedText';
export function buildSolutionsPartnerProfileInfoListSections({
  budget,
  credentials,
  industries,
  languages,
  regions,
  services
}) {
  const sectionsData = [];
  if (services !== null && services !== void 0 && services.length) {
    sectionsData.push({
      label: unescapedText('detailsPage.productCredentialsCard.sections.SERVICES'),
      items: services.map(service => ({
        name: service.name
      }))
    });
  }
  if (industries !== null && industries !== void 0 && industries.length) {
    sectionsData.push({
      expandable: false,
      label: unescapedText('detailsPage.productCredentialsCard.sections.INDUSTRIES'),
      items: industries.map(industry => ({
        name: unescapedText(`marketplace-ui-common.industry.${industry}.title`)
      }))
    });
  }
  if (budget) {
    sectionsData.push({
      expandable: false,
      label: unescapedText('detailsPage.productCredentialsCard.sections.BUDGETS'),
      items: [{
        name: unescapedText(`detailsPage.productCredentialsCard.budget.${budget}`)
      }]
    });
  }
  if (languages !== null && languages !== void 0 && languages.length) {
    sectionsData.push({
      expandable: false,
      label: unescapedText('detailsPage.productCredentialsCard.sections.LANGUAGES'),
      items: languages.map(language => ({
        name: unescapedText(`SharedI18nStrings.languageNames.${language}`)
      }))
    });
  }
  if (regions !== null && regions !== void 0 && regions.length) {
    sectionsData.push({
      expandable: false,
      label: unescapedText('detailsPage.productCredentialsCard.sections.REGIONS'),
      items: regions.map(region => ({
        name: unescapedText(`detailsPage.productCredentialsCard.region.${region}`)
      }))
    });
  }
  if (credentials !== null && credentials !== void 0 && credentials.length) {
    ['ACCREDITATION', 'CERTIFICATION', 'BADGE'].filter(type => {
      return credentials.some(credential => credential.type === type && credential.title);
    }).forEach(type => {
      const filteredCredentials = credentials.filter(credential => credential.type === type && credential.title);
      sectionsData.push({
        label: unescapedText(`detailsPage.productCredentialsCard.sections.${type}`),
        items: filteredCredentials.map(credential => ({
          key: credential.id,
          name: credential.title,
          icon: credential.icon
        }))
      });
    });
  }

  // Sort alphabetically
  sectionsData.forEach(section => {
    section.items = section.items.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
  });
  return sectionsData;
}